export const FIREBASE_CONFIGS = {
  prod: {
    authDomain: "routetitan-prod-274110.firebaseapp.com",
    projectId: "routetitan-prod-274110",
    storageBucket: "routetitan-prod-274110.appspot.com",
    messagingSenderId: "909319130757",
    appId: "1:909319130757:web:829a98f3b509976f09e3ec",
    measurementId: "G-NRR6FS25Q5"
  },
  stag: {
    authDomain: "routetitan-stag.firebaseapp.com",
    projectId: "routetitan-stag",
    storageBucket: "routetitan-stag.appspot.com",
    messagingSenderId: "576491159185",
    appId: "1:576491159185:web:b1f998c9b0d585cc2ec930",
    measurementId: "G-QGY9PSWEJH"
  },
  test: {
    authDomain: "routetitan-test-276508.firebaseapp.com",
    projectId: "routetitan-test-276508",
    storageBucket: "routetitan-test-276508.appspot.com",
    messagingSenderId: "1050772657330",
    appId: "1:1050772657330:web:bb9787b2132ac6a37e65ab",
    measurementId: "G-R4D68B6GZT"
  },
  dev: {
    authDomain: "routetitan-dev.firebaseapp.com",
    projectId: "routetitan-dev",
    storageBucket: "routetitan-dev.appspot.com",
    messagingSenderId: "962137138785",
    appId: "1:962137138785:web:ce2be3abbbf46912472c20",
    measurementId: "G-QMTRSZ5HDM"
  }
};
